var Floaty = /** @class */ (function () {
    function Floaty(element) {
        var _this = this;
        this.offset = 0;
        this.onFloatListeners = [];
        this.onUnfloatListeners = [];
        this.element = element;
        this.floatingEl = element.querySelector('.floatable');
        if (this.element.hasAttribute('data-floaty-offset')) {
            this.offset = parseInt(this.element.getAttribute('data-floaty-offset'));
        }
        if (document.body.classList.contains('admin-bar')) {
            this.adminBarSupport();
        }
        window.addEventListener('scroll', function () { return _this.update(); });
        window.addEventListener('resize', function () { return _this.update(); });
        window.addEventListener('load', function () { return _this.update(); });
        document.addEventListener('readystatechange', function () { return _this.update(); });
        this.update();
    }
    Floaty.prototype.update = function () {
        var eTop = this.element.offsetTop + this.offset;
        var winTop = window.scrollY;
        if (winTop > eTop && !this.floatingEl.classList.contains('is-floating')) {
            //Push down content
            this.element.style.marginBottom = this.floatingEl.offsetHeight + 'px';
            //Set nav to floating
            this.floatingEl.classList.add('is-floating');
            this.floatingEl.style.position = 'fixed';
            this.floatingEl.style.left = '0';
            this.floatingEl.style.right = '0';
            this.floatingEl.style.top = '0';
            this.callListeners(this.onFloatListeners);
        }
        else if (eTop - winTop >= 0 && this.floatingEl.classList.contains('is-floating')) {
            //Push up content
            this.element.style.marginBottom = '0';
            //Set nav to not floating
            this.floatingEl.classList.remove('is-floating');
            this.floatingEl.style.position = '';
            this.callListeners(this.onUnfloatListeners);
        }
    };
    Floaty.prototype.callListeners = function (listeners) {
        var _this = this;
        listeners.forEach(function (listener) { return listener.call(_this); });
    };
    Floaty.prototype.onFloat = function (listener) {
        this.onFloatListeners.push(listener);
    };
    Floaty.prototype.onUnfloat = function (listener) {
        this.onUnfloatListeners.push(listener);
    };
    Floaty.prototype.adminBarSupport = function () {
        var _this = this;
        var adminbar = document.getElementById('wpadminbar');
        if (getComputedStyle(adminbar).position !== 'fixed') {
            return;
        }
        var height = adminbar.offsetHeight;
        this.offset -= height;
        this.onFloat(function () {
            _this.floatingEl.style.marginTop = height + 'px';
        });
        this.onUnfloat(function () {
            _this.floatingEl.style.marginTop = '0';
        });
    };
    return Floaty;
}());
export default Floaty;
